<template>
  <div class="robu-container-wrapper" ref="containerWrapper">
    <div class="image-text-section" ref="imageTextSection">
      <!-- 顶部图片区域 -->
      <div class="ro-top-image-container" ref="topImageContainer">
        <img
            :src="imageSrc"
            :alt="imageAlt"
            class="top-image"
            @load="handleImageLoad"
            ref="topImage"
        >
      </div>

      <div class="bottom-text-container" ref="bottomTextContainer">
        <!-- 左侧渐变色大字体 -->
        <div class="ro-left-gradient-text" :style="gradientStyle" ref="leftGradientText">
          {{ leftLargeText }}
        </div>
        <!-- 右侧上下文字区域 -->
        <div class="right-text-content" ref="rightTextContent">
          <div class="right-text-top" ref="rightTextTop">
            {{ rightTopText }}
          </div>
          <div class="right-text-bottom" ref="rightTextBottom">
            <span class="text-block">{{ $t('series.tank_desc')}}</span>
            <span class="text-block">{{ $t('series.tank_desc1')}}</span>
            <span class="text-block">{{ $t('series.tank_desc2')}}</span>
            <span class="text-block">{{ $t('series.tank_desc3')}}</span>
            <span class="text-block">{{ $t('series.tank_desc4')}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import image1 from "../../static/series/cutbed/MachineRobustness.png"

export default {
  name: 'ImageTextSection',
  props: {
    // 顶部图片
    imageSrc: {
      type: String,
      default: image1
    },
    imageAlt: {
      type: String,
      default: '顶部展示图片'
    },
    // 渐变颜色（可自定义）
    gradientFrom: {
      type: String,
      default: '#0066CC'
    },
    gradientTo: {
      type: String,
      default: '#66CCFF'
    },
    // 组件宽度占比（百分比）
    widthPercentage: {
      type: Number,
      default: 80,
      validator: (value) => {
        return value > 0 && value <= 100;
      }
    }
  },
  data() {
    return {
      // 左侧大字体文字
      leftLargeText: this.$i18n.t('series.unbreakable'),
      // 右侧上部文字
      rightTopText: this.$i18n.t('series.tank'),
      imageLoaded: false,
      animationInited: false,
      isMobile: false
    };
  },
  methods: {
    handleImageLoad() {
      this.imageLoaded = true;
      this.checkImageLoaded();
    },
    checkImageLoaded() {
      if (this.imageLoaded && !this.animationInited) {
        this.initAnimations();
        this.animationInited = true;
      }
    },
    checkDevice() {
      this.isMobile = window.innerWidth < 768;
    },
    initAnimations() {
      const isMobile = this.isMobile;
      const baseY = isMobile ? 80 : 150;
      const textY = isMobile ? 50 : 100;
      const duration1 = isMobile ? 0.6 : 0.8;
      const duration2 = isMobile ? 0.8 : 1;

      const masterTimeline = this.$gsap.timeline({
        scrollTrigger: {
          trigger: this.$refs.containerWrapper,
          start: isMobile ? 'top 90%' : 'top 80%',
          end: isMobile ? 'center 60%' : 'center 50%',
          markers: false,
          toggleActions: 'play none none none',
          once: true
        }
      });

      masterTimeline
          .from(['.ro-top-image-container'], {
            y: baseY,
            duration: duration1,
            ease: 'power2.in'
          }, 0)
          .from([this.$refs.leftGradientText, this.$refs.rightTextTop, this.$refs.rightTextBottom], {
            y: textY,
            duration: duration2,
            ease: 'power2.in',
            transformOrigin: "0% 0%"
          }, 0.3);

      // const masterTimeline2 = this.$gsap.timeline({
      //   scrollTrigger: {
      //     trigger: this.$refs.containerWrapper,
      //     start: isMobile ? 'top -10%' : 'top -20%',
      //     end: isMobile ? 'bottom 30%' : 'bottom 20%',
      //     toggleActions: 'play none none reverse',
      //   }
      // });
      // masterTimeline2.to(this.$refs.containerWrapper, {
      //   y: exitY,
      //   duration: 1.5,
      //   ease: 'power2.in'
      // });
    }
  },
  computed: {
    gradientStyle() {
      return {
        background: `linear-gradient(to right, ${this.gradientFrom}, ${this.gradientTo})`,
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent'
      };
    },
    containerWidth() {
      return `${this.widthPercentage}%`;
    }
  },
  mounted() {
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);

    this.$nextTick(() => {
      if (this.$refs.topImage.complete) {
        this.imageLoaded = true;
        this.checkImageLoaded();
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
  }
};
</script>

<style scoped>
/* 基础样式保持不变 */
.robu-container-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 0;
  margin: 0;
  margin-top: 500px;
}

.image-text-section {
  width: v-bind(containerWidth);
  display: flex;
  flex-direction: column;
}

.ro-top-image-container {
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
}

.top-image {
  width: 80%;
  height: auto;
  display: block;
  object-fit: cover;
}

.top-image:not([src]) {
  opacity: 0;
  min-height: 300px;
}

.bottom-text-container {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 200px;
  margin-top: 80px;
}

.ro-left-gradient-text {
  flex: 1;
  display: flex;
  align-items: center;
  font-size: var(--font-size-xl2);
  font-weight: 700;
  line-height: 1.2;
  text-align: left;
  height: 100%;
  box-sizing: border-box;
  justify-content: space-around;
}

.right-text-content {
  flex: 1;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  box-sizing: border-box;
  gap: 1.5rem;
}

.right-text-top {
  font-size: 2em;
  color: #000;
  line-height: 1.5;
  margin: 0;
  text-align: left;
}

.right-text-bottom {
  font-size: 1.2em;
  color: #808080;
  line-height: 1.6;
  margin: 0;
  text-align: left;
  width: 600px;
}

.text-block {
  display: block;
}

.text-block:last-child {
  margin-bottom: 0;
}

/* 手机端优化 - 重点调整 */
@media (max-width: 768px) {
  .robu-container-wrapper {
    margin-top: 150px;
    padding: 0 5%; /* 整体左右留白 */
  }

  .image-text-section {
    width: 100%;
  }

  /* 图片位置精确调整 */
  .ro-top-image-container {
    padding: 0 5%; /* 图片容器左右留白，控制图片显示范围 */
    margin: 0 auto 20px; /* 底部增加间距，与文字区域分离 */
    width: 100%; /* 占满父容器 */
  }

  .top-image {
    width: 100%; /* 图片填满容器 */
    max-width: 400px; /* 限制最大宽度，避免在大屏手机上过大 */
    border-radius: 8px; /* 增加圆角，提升视觉效果 */
    padding-left: 0;
  }

  .bottom-text-container {
    flex-direction: column; /* 垂直布局 */
    margin-top: 20px; /* 减小图片与文字的距离 */
    gap: 20px; /* 增加文字区域间距 */
    padding: 0 5%; /* 与整体留白一致 */
  }

  /* 左侧渐变文字 */
  .ro-left-gradient-text {
    font-size: clamp(24px, 6vw, 32px);
    width: 100%;
    justify-content: flex-start; /* 左对齐 */
    padding: 0;
  }

  /* 右侧文字区域 - 宽度设置为75% */
  .right-text-content {
    width: 75%; /* 核心设置：右侧文字宽度75% */
    padding: 0; /* 移除内边距，避免宽度被挤压 */
    gap: 1rem;
    align-self: flex-start; /* 左对齐，与左侧文字保持一致 */
  }

  .right-text-top {
    font-size: clamp(18px, 5vw, 24px);
  }

  .right-text-bottom {
    font-size: clamp(14px, 4vw, 16px);
    width: 100%; /* 跟随父容器宽度 */
    line-height: 1.6;
  }
}

/* 小屏手机额外优化 */
@media (max-width: 480px) {
  .robu-container-wrapper {
    margin-top: 100px;
  }

  .ro-top-image-container {
    padding: 0 3%;
  }

  .top-image {
    max-width: 320px; /* 进一步限制小屏图片宽度 */
  }

  .right-text-content {
    width: 85%; /* 小屏适当放宽宽度 */
  }

  .ro-left-gradient-text {
    font-size: clamp(22px, 7vw, 28px);
  }
}
</style>
